import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./core/auth/auth.guard";
import { SignupComponent } from "./core/auth/signup/signup.component";
import { LoginComponent } from "./core/auth/login/login.component";
import { ResetPasswordComponent } from "./core/auth/reset-password/reset-password.component";
import { subscriptionGuard } from "./core/subscription.guard";
import { availabilityGuard } from "./core/availability/availability.guard";
import { AvailabilityComponent } from "./core/availability/availability/availability.component";
import { environment } from "../environments/environment";

const routes: Routes = [
  {
    path: "account",
    loadChildren: () =>
      import("./modules/account/account.module").then((m) => m.AccountModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: "signup",
    component: SignupComponent,
    canActivate: [availabilityGuard],
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
  },
  {
    path: "availability",
    component: AvailabilityComponent,
  },
  {
    path: "launch",
    loadChildren: () =>
      import("./modules/launch/launch.module").then((m) => m.LaunchModule),
    canActivate: [AuthGuard],
    data: { fullscreen: true },
  },
  {
    path: "subscribe",
    loadChildren: () =>
      import("./modules/subscription/subscription.module").then(
        (m) => m.SubscriptionModule,
      ),
    canActivateChild: [AuthGuard],
  },
  ...(environment.browserStreaming
    ? [
        {
          path: "stream",
          loadChildren: () =>
            import("./modules/stream/stream.module").then(
              (m) => m.StreamModule,
            ),
          canActivate: [AuthGuard],
          data: { fullscreen: true },
        },
      ]
    : []),
  {
    path: "",
    loadChildren: () =>
      import("./modules/dashboard/dashboard.module").then(
        (m) => m.DashboardModule,
      ),
    canActivateChild: [AuthGuard, subscriptionGuard],
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
